import React, { useEffect, useState } from 'react'
import { getFormStatusMessages, SaveFormStatusMessages } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

export default function Main({ admin, pageViewHandler }) {
    const [List, setList] = useState([])
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [editingRow, setEditingRow] = useState(null)   // formStatus of the row being edited
    const [editedMessage, setEditedMessage] = useState("")

    useEffect(() => {
        getFormStatusList()
    }, [])

    const getFormStatusList = () => {
        setLoader(true)
        getFormStatusMessages(callback => {
            setList(callback?.data ?? [])
            setLoader(false)
        })
    }

    const handleEditClick = (item) => {
        setEditingRow(item.formStatus)
        setEditedMessage(item.message)
    }

    const handleCancelEdit = () => {
        setEditingRow(null)
        setEditedMessage("")
    }

    const handleSave = (formStatus) => {
        const data = {
            formStatus,
            message: editedMessage,
            addedBy: admin.emailId
        }
        setLoader(true)
        SaveFormStatusMessages(data, callback => {
            setLoader(false)
            if (callback?.message === "success") {
                setpopup({ show: true, popupStatus: "Success!" })
                setList(prev =>
                    prev.map(item =>
                        item.formStatus === formStatus
                            ? { ...item, message: editedMessage, addedBy: admin.emailId }
                            : item
                    )
                )
                setEditingRow(null)
                setEditedMessage("")
            } else {
                setpopup({ show: true, popupStatus: "Error: please try again later!" })
            }
            setTimeout(() => closePopup(), 5000)
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }

    return (
        <div style={styles.container}>
            {popup?.show && (
                <Popup popupStatus={popup.popupStatus} closePopup={closePopup} />
            )}

            {loader && <Loader />}

            <div style={styles.header}>
                <h2 style={styles.title}>Form Status Messages</h2>
            </div>

            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead>
                        <tr style={styles.thead}>
                            <th style={{ ...styles.th, width: '40px' }}>#</th>
                            <th style={styles.th}>Form Status</th>
                            <th style={styles.th}>Message</th>
                            <th style={styles.th}>Added By</th>
                            <th style={{ ...styles.th, width: '120px' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {List.length === 0 && !loader ? (
                            <tr>
                                <td colSpan={5} style={styles.emptyCell}>No records found.</td>
                            </tr>
                        ) : (
                            List.map((item, index) => {
                                const isEditing = editingRow === item.formStatus
                                return (
                                    <tr key={item.formStatus} style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                                        <td style={styles.td}>{index + 1}</td>
                                        <td style={styles.td}>
                                            <span style={styles.badge}>{item.formStatus}</span>
                                        </td>
                                        <td style={styles.td}>
                                            {isEditing ? (
                                                <input
                                                    type="text"
                                                    value={editedMessage}
                                                    onChange={e => setEditedMessage(e.target.value)}
                                                    style={styles.input}
                                                    autoFocus
                                                    placeholder="Enter message..."
                                                />
                                            ) : (
                                                <span style={item.message ? styles.messageText : styles.emptyMessage}>
                                                    {item.message || "—"}
                                                </span>
                                            )}
                                        </td>
                                        <td style={styles.td}>
                                            <span style={styles.addedBy}>{item.addedBy || "—"}</span>
                                        </td>
                                        <td style={styles.td}>
                                            {isEditing ? (
                                                <div style={styles.actionGroup}>
                                                    <button
                                                        style={styles.saveBtn}
                                                        onClick={() => handleSave(item.formStatus)}
                                                        disabled={loader}
                                                    >
                                                        Save
                                                    </button>
                                                    <button
                                                        style={styles.cancelBtn}
                                                        onClick={handleCancelEdit}
                                                        disabled={loader}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    style={styles.editBtn}
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const styles = {
    container: {
        padding: '24px',
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        color: '#1a1a2e',
    },
    header: {
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        margin: 0,
        color: '#1a1a2e',
    },
    tableWrapper: {
        overflowX: 'auto',
        borderRadius: '10px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
    },
    thead: {
        backgroundColor: '#f8fafc',
    },
    th: {
        padding: '12px 16px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '13px',
        color: '#64748b',
        borderBottom: '1px solid #e2e8f0',
        whiteSpace: 'nowrap',
    },
    td: {
        padding: '11px 16px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #f1f5f9',
    },
    rowEven: {
        backgroundColor: '#ffffff',
    },
    rowOdd: {
        backgroundColor: '#fafbfc',
    },
    badge: {
        display: 'inline-block',
        backgroundColor: '#eff6ff',
        color: '#2563eb',
        borderRadius: '5px',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: '500',
    },
    messageText: {
        color: '#334155',
    },
    emptyMessage: {
        color: '#94a3b8',
        fontStyle: 'italic',
    },
    addedBy: {
        color: '#64748b',
        fontSize: '13px',
    },
    input: {
        width: '100%',
        padding: '6px 10px',
        border: '1px solid #93c5fd',
        borderRadius: '6px',
        fontSize: '14px',
        outline: 'none',
        boxSizing: 'border-box',
        color: '#1e293b',
        backgroundColor: '#f0f9ff',
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
    },
    editBtn: {
        padding: '5px 14px',
        backgroundColor: '#2563eb',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '500',
    },
    saveBtn: {
        padding: '5px 12px',
        backgroundColor: '#16a34a',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '500',
    },
    cancelBtn: {
        padding: '5px 12px',
        backgroundColor: '#e2e8f0',
        color: '#475569',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '500',
    },
    emptyCell: {
        padding: '32px',
        textAlign: 'center',
        color: '#94a3b8',
        fontSize: '14px',
    },
}